// removed by extract-text-webpack-plugin
module.exports = {"CookieNotice":"_1jdRtHVWAJeZYiThQ7iRwO","CookieNotice__inner":"_2wZw1kbRZ7tpaT2W10_4Q8","CookieNotice__discard":"_15WVfUkhRiz3i-8scHl59q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CookieNotice/CookieNotice.scss
// module id = 2734
// module chunks = 0